import {
  LOGIN,
  LOGOUT,
  VERIFYPHONENUMBER,
} from "./action.types";
import { callPlainApi } from "../../utils/apiRequest";
import { saveCookie } from "../../utils/helpers";

export const sendLoginRequest = (data, history, cb = () => {}) => async (
  dispatch
) => {
  const authenticate = true;
  try {
    const authResponse = await callPlainApi("/login", data, "POST");
    const { token, data: user } = authResponse;
    dispatch({
      type: LOGIN,
      user: user,
      token,
      userRole: user.userRole,
      authenticated: authenticate,
    });
    saveCookie("tractrac", token);
    history.push("/user/dashboard");
  } catch (error) {
    cb(null, error);
  }
};

export const sendRegisterRequest = (data, history, cb = () => {}) => async (
  dispatch
) => {
  const authenticate = false;
  try {
    const authResponse = await callPlainApi("/signup", data, "POST");
    const { token, data: user } = authResponse;
    dispatch({
      type: LOGIN,
      user: user,
      token,
      userRole: user.userRole,
      authenticated: authenticate,
    });
    saveCookie("tractrac", token);

    // history.push("/verify-token");
    history.push("/user/dashboard");
  } catch (error) {
    cb(null, error);
  }
};

// send your phone number to get a verification link
export const sendForgotPasswordRequest = (
  data,
  history,
  cb = () => {}
) => async (dispatch) => {
  try {
    
    const authResponse = await callPlainApi("/send-otp-code", data, "POST");
    if (authResponse) {
      history.push({
        pathname: "/verify",
        state: { ...data}
      });
    }
  } catch (error) {
    cb(null, error);
  }
};

export const sendLogoutRequest = () => async (dispatch) => {
  dispatch({
    type: LOGOUT,
  });
};

// for verifying a user phone number upon registration
export const verifyPhoneNumber = (data, history, cb = () => {}) => async (
  dispatch
) => {
  try {
    await callPlainApi("/user/account-activation", data, "POST");
    dispatch({
      type: VERIFYPHONENUMBER,
    });
    history.push("/");
  } catch (error) {
    cb(null, error);
  }
};

// for verifying a user phone number when the request for password reset
export const VerifyTokenForPasswordReset = (
  data,
  history,
  cb = () => {}
) => async (dispatch) => {
  try {
    const response = await callPlainApi("/verify", data, "POST");
    if(response) {
      history.push("/reset-password");
    }
  } catch (error) {
    cb(null, error);
  } finally {
    cb()
  }
};
